import React, { Component } from 'react'
import ReactTable from 'react-table'
import {
  Button,
  Form,
  Modal,
  Popconfirm,
  Input,
  InputNumber,
  Checkbox,
  Row,
  Col,
  Table,
  DatePicker,
  AutoComplete,
  Icon,
  Radio,
  message,
  Upload,
  Tooltip,
  Spin
} from 'antd'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import _ from 'lodash'
import styled from 'styled-components'
import { actions as transmittalActions } from '../../../redux/modules/jobFunctions/jobSiteTransmittalActions'
import { actions as organizationsActions } from '../../../redux/modules/organizationsActions'
import Loader from '../../common/Loader'
import {
  convertToOption,
  filterCaseInsensitive,
  arrayMove,
  getSelectedOrganization,
  getModalId
} from '../../../util'
import config from '../../../config'
import OrganizationQuickAdd from '../../../components/organization//OrganizationQuickAdd'
import history from '../../../history'

const { API_BASE } = config
const AddItemArea = styled.div`
  padding-top: 10px;
  margin-bottom: 10px;
  padding-right: 10px;
`

const SignedFilesUploadContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  -webkit-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  -moz-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
`

const EditAttachmentContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  background-color: #eeeeee;
`
const EditAttachmentTitle = styled.h6`
  color: #fff;
`
const EditingFileContainer = styled.div`
  margin: 10px 0;
`

const FormItem = Form.Item
const { TextArea } = Input
const { Column } = Table
const RadioButton = Radio.Button
const RadioGroup = Radio.Group
const propTypes = {}

const EditableCell = ({ editable, value, onChange }) => (
  <div>
    {editable ? (
      <Input style={{ margin: '-5px 0' }} value={value} onChange={e => onChange(e.target.value)} />
    ) : (
      value
    )}
  </div>
)
class JobSiteTransmittals extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      currentId: getModalId(props.location.pathname),
      contentData: null,
      transmittalItems: [],
      transmittalSendings: [],
      transmittalTransmitteds: [],
      addDateInput: null,
      addCopiesInput: 0,
      addNumberInput: 0,
      addDescriptionInput: '',
      transmittalStatus: null,
      quickAddModal: false
    }

    this.props.jobSiteTransmittalsRefresh({
      jobId: this.props.jobId,
      next: (payload, err) => {
        const changeOrderId = getModalId(this.props.location.pathname)
        if (changeOrderId) {
          if (!err) {
            const results = _.get(payload, 'data')
            const current = _.find(results, { id: parseInt(changeOrderId, 10) })
            if (current) {
              setTimeout(() => this.handleRowClick(current), 500)
            } else {
              message.warning('This Purchase Order was deleted or does not exist.')
            }
          }
        }
      }
    })
    this.props.getAllOrganizations()
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.jobSiteTransmittalActions.transmittalData !==
      prevProps.jobSiteTransmittalActions.transmittalData
    ) {
      this.setState({
        transmittalItems: this.props.jobSiteTransmittalActions.transmittalData.payload
          .transmittal_items,
        transmittalSendings: this.props.jobSiteTransmittalActions.transmittalData.payload
          .sending_items,
        transmittalTransmitteds: this.props.jobSiteTransmittalActions.transmittalData.payload
          .transmitted_items
      })
    }
  }

  handleRowClick = row => {
    this.setState({
      currentId: row.id,
      contentData: row,
      transmittalStatus: row.status,
      transmittedOtherShow: row.transmitted_other ? true : false,
      sendingOtherShow: row.sending_other ? true : false
    })
    const { jobId, jobType } = this.props.match.params
    history.push(`/jobView/${jobId}/${jobType}/transmittals/modal/${row.id}`)
    this.props.getTransmittalData(row.id)

    this.props.getTransmittalAttachments({
      transmittalId: row.id
    })
  }

  handleAddButton = () => {
    const { jobId, jobType } = this.props.match.params
    history.push(`/jobView/${jobId}/${jobType}/transmittals/modal/0`)
    this.setState({
      currentId: 0,
      contentData: null,
      transmittalItems: [],
      transmittalSendings: [],
      transmittalTransmitteds: [],
      addDateInput: null,
      addCopiesInput: 0,
      addNumberInput: 0,
      addDescriptionInput: ''
    })
  }

  handleCancel = () => {
    this.props.form.resetFields()
    const { jobId, jobType } = this.props.match.params
    history.push(`/jobView/${jobId}/${jobType}/transmittals`)
    this.setState({ data: [], currentId: 0, attachmentDetailsVisible: null })
  }

  handleCreate = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      // remove other text or not
      values.sending_other_text = this.state.sendingOtherShow ? values.sending_other_text : null
      values.transmitted_other_text = this.state.transmittedOtherShow
        ? values.transmitted_other_text
        : null

      values.organization_id = getSelectedOrganization(
        this.props.organizationsActions.payload.data,
        values.organization_id
      )

      if (this.state.currentId === 0) {
        this.props.createTransmittal({
          jobId: this.props.jobId,
          content: values,
          sending: this.state.transmittalSendings,
          transmittalItems: this.state.transmittalItems,
          transmitted: this.state.transmittalTransmitteds,
          userId: this.props.user.userId
        })
      } else {
        this.props.updateTransmittal({
          jobId: this.props.jobId,
          transmittalId: this.state.currentId,
          content: values,
          sending: this.state.transmittalSendings,
          transmittalItems: this.state.transmittalItems,
          transmitted: this.state.transmittalTransmitteds,
          userId: this.props.user.userId
        })
      }

      form.resetFields()
      message.success('Changes saved.')
      const { jobId, jobType } = this.props.match.params
      history.push(`/jobView/${jobId}/${jobType}/transmittals`)
      this.setState({
        contentData: null,
        currentId: 0,
        transmittalItems: [],
        transmittalSendings: [],
        transmittalTransmitteds: [],
        addDateInput: null,
        addCopiesInput: 0,
        addNumberInput: 0,
        addDescriptionInput: ''
      })
    })
  }

  confirmDelete = event => {
    const form = this.props.form

    this.props.deleteTransmittal({
      jobId: this.props.jobId,
      transmittalId: this.state.currentId
    })

    form.resetFields()
    message.success('Record deleted.')
    const { jobId, jobType } = this.props.match.params
    history.push(`/jobView/${jobId}/${jobType}/transmittals`)
    this.setState({
      contentData: null,
      modalVisible: false
    })
  }

  onSendingCheckBoxGroupChange = checkedValues => {
    this.setState({
      transmittalSendings: checkedValues,
      sendingOtherShow: checkedValues.includes('sending_other') ? true : false
    })
  }

  onTransmittedCheckBoxGroupChange = checkedValues => {
    this.setState({
      transmittalTransmitteds: checkedValues,
      transmittedOtherShow: checkedValues.includes('transmitted_other') ? true : false
    })
  }

  renderColumns(text, record, column) {
    return (
      <EditableCell
        editable={record.isEditingRow}
        value={text}
        onChange={value => this.handleItemsInputChange(value, record.id, column)}
      />
    )
  }

  handleItemsInputChange = (value, key, column) => {
    const groupedItems = this.state.transmittalItems.map(row => {
      if (row.id === key) row[column] = value
      return row
    })
    this.setState({
      transmittalItems: groupedItems
    })
  }

  handleAddInputChange = (value, input) => {
    this.setState({ [input]: value })
  }

  handleAddItemClick = () => {
    const items = this.state.transmittalItems

    items.push({
      transmittal_date: moment.utc(this.state.addDateInput).format('YYYY-MM-DD'),
      copies: this.state.addCopiesInput,
      number: this.state.addNumberInput,
      description: this.state.addDescriptionInput,
      id: items.length
    })
    this.setState({
      addDateInput: null,
      addCopiesInput: 0,
      addNumberInput: 0,
      addDescriptionInput: '',
      transmittalItems: items
    })
  }

  editRow = rowId => {
    const groupedItems = this.state.transmittalItems.map(row => {
      if (row.id === rowId) row.isEditingRow = true
      return row
    })
    this.setState({
      transmittalItems: groupedItems
    })
  }

  saveRow = rowId => {
    const groupedItems = this.state.transmittalItems.map(row => {
      if (row.id === rowId) {
        row.isEditingRow = false
      }
      return row
    })
    this.setState({
      transmittalItems: groupedItems
    })
  }

  deleteRow = rowId => {
    const groupedItems = this.state.transmittalItems.filter(item => item.id !== rowId)

    this.setState({
      transmittalItems: groupedItems
    })
  }

  handleStatusChange = event => {
    this.setState({
      transmittalStatus: event.target.value
    })
  }

  uploadAttachment = uploadParam => {
    const formData = new FormData()

    formData.append('file', uploadParam.file)
    formData.append('type', 'job_transmittal')
    formData.append('filename', uploadParam.file.name)
    formData.append('description', uploadParam.file.name)
    formData.append('transmittalId', this.state.currentId)

    this.props.uploadAttachment({
      formData: formData,
      transmittalId: this.state.currentId
    })
  }

  handleAttachmentRowClick = row => {
    this.setState({
      attachmentDetailsVisible: true,
      attachmentId: row.id,
      attachmentName: row.filename,
      attachmentDescription: row.description
    })
  }

  onChangeAttachmentDescription = () => {
    this.props.updateAttachmentDescription({
      description: this.state.attachmentDescription,
      attachmentId: this.state.attachmentId,
      transmittalId: this.state.currentId,
      userId: this.props.user.userId
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  onDescriptionChange = e => {
    this.setState({
      attachmentDescription: e.target.value
    })
  }

  confirmAttachmentDelete = event => {
    this.props.deleteAttachment({
      attachmentId: this.state.attachmentId,
      transmittalId: this.state.currentId
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  moveUp = index => {
    const i = _.findIndex(this.state.transmittalItems, { id: index })
    this.setState({
      requestItems: arrayMove(this.state.transmittalItems, i, i - 1)
    })
  }

  moveDown = index => {
    const i = _.findIndex(this.state.transmittalItems, { id: index })
    this.setState({
      requestItems: arrayMove(this.state.transmittalItems, i, i + 1)
    })
  }

  /* Organization Quick Add */
  handleQuickAddOrganization = organization => {
    this.props.createNewOrganization({
      organization: organization,
      userId: this.props.user.userId
    })
    setTimeout(() => {
      this.props.getAllOrganizations()
    }, 1000)
  }

  handleBlurOrganization = organization => {
    if (organization !== '')
      this.setState({
        quickAddModalVisibility:
          _.findIndex(this.props.organizationsActions.payload.data, { id: +organization }) < 0 &&
          _.findIndex(this.props.organizationsActions.payload.data, { name: organization }) < 0
            ? true
            : false
      })
  }

  handleCancelQuickAdd = () => {
    this.setState({
      quickAddModalVisibility: !this.state.quickAddModalVisibility
    })
  }
  /* End Organization Quick Add */

  shouldRenderModal = () => {
    return /modal\/\d+$/.test(window.location.href)
  }

  render() {
    const { contentData } = this.state

    const uploadProps = {
      multiple: true,
      fileList: this.state.fileList
    }

    const { getFieldDecorator } = this.props.form
    if (!this.props.jobSiteTransmittalActions.jobSiteTransmittals) {
      return <Loader />
    }
    return (
      <div>
        <OrganizationQuickAdd
          modalVisible={this.state.quickAddModalVisibility}
          handleCancel={this.handleCancelQuickAdd}
          handleQuickAddOrganization={this.handleQuickAddOrganization}
          organizartionType={'Client'}
        />
        {this.shouldRenderModal() && (
          <Modal
            visible={true}
            title="Transmittals"
            okText={contentData ? 'Save Changes' : 'Create'}
            onCancel={this.handleCancel}
            onOk={this.handleCreate}
            width="90%"
            maskClosable={false}
          >
            {contentData && (
              <div className="row">
                <div className="col-md-11">
                  <FormItem label="Status">
                    {getFieldDecorator('status', {
                      initialValue: contentData ? contentData.status : ''
                    })(
                      <RadioGroup onChange={this.handleStatusChange}>
                        <RadioButton value="Created">Created</RadioButton>
                        <RadioButton value="Sent">Sent</RadioButton>
                      </RadioGroup>
                    )}
                  </FormItem>
                </div>
                <div className="col-md-1 text-right">
                  <a
                    href={`${API_BASE}/api/job/job_site_transmittals/print/${contentData.id}`}
                    target="_blank"
                  >
                    <Button icon="printer" className="marginRight10" />
                  </a>
                </div>
              </div>
            )}
            {contentData && (
              <div className="row">
                <div className="col-md-3">
                  <div className="jobDetailsHeader">Created Date</div>
                  {`${moment(contentData.created_date).format('M/D/YYYY h:mm:ssa')}`}
                </div>
                <div className="col-md-3">
                  <div className="jobDetailsHeader">Updated Date</div>
                  {`${moment(contentData.updated_date).format('M/D/YYYY h:mm:ssa')}`}
                </div>
                <div className="col-md-3">
                  <div className="jobDetailsHeader">Created by</div>
                  {`${contentData.first_name} ${contentData.last_name}`}
                </div>
                <div className="col-md-3">
                  <div className="jobDetailsHeader">Updated by</div>
                  {`${contentData.updated_by_first_name} ${contentData.updated_by_last_name}`}
                </div>
              </div>
            )}
            <div className="row">
              <div className="col-md-6">
                <FormItem label="Company/Vendor Name">
                  {getFieldDecorator('organization_id', {
                    rules: [
                      {
                        required: true,
                        message: 'Company cannot be blank.'
                      }
                    ],
                    initialValue: contentData ? contentData.organization_name : ''
                  })(
                    <AutoComplete
                      dataSource={
                        this.props.organizationsActions &&
                        this.props.organizationsActions.payload &&
                        convertToOption(this.props.organizationsActions.payload.data)
                      }
                      onBlur={this.handleBlurOrganization}
                      filterOption={(inputValue, option) =>
                        option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                      }
                      style={{ width: 320 }}
                      placeholder="Search for a company/vendor"
                    >
                      <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                    </AutoComplete>
                  )}
                </FormItem>
              </div>
              <div className="col-md-6">
                <FormItem label="Attention">
                  {getFieldDecorator('attention', {
                    initialValue: contentData ? contentData.attention : ''
                  })(<Input placeholder="Attention to..." />)}
                </FormItem>
              </div>
            </div>
            <Form layout="vertical">
              <FormItem label="Description">
                {getFieldDecorator('description', {
                  rules: [
                    {
                      required: true,
                      message: 'Description cannot be blank.'
                    }
                  ],
                  initialValue: contentData ? contentData.description : ''
                })(<TextArea placeholder="Describe the transmittal..." rows={4} />)}
              </FormItem>
              <h5>We are sending to you:</h5>
              <Checkbox.Group
                style={{ width: '100%' }}
                onChange={this.onSendingCheckBoxGroupChange}
                value={this.state.transmittalSendings}
              >
                <Row>
                  <Col span={8}>
                    <Checkbox value="sending_shop_drawings">Shop Drawings</Checkbox>
                  </Col>
                  <Col span={8}>
                    <Checkbox value="sending_letter">Letter</Checkbox>
                  </Col>
                  <Col span={8}>
                    <Checkbox value="sending_specifications">Specifications</Checkbox>
                  </Col>
                  <Col span={8}>
                    <Checkbox value="sending_rfi">RFI</Checkbox>
                  </Col>
                  <Col span={8}>
                    <Checkbox value="sending_sample">Sample</Checkbox>
                  </Col>
                  <Col span={8}>
                    <Checkbox value="sending_final_drawings">Final Drawings</Checkbox>
                  </Col>
                  <Col span={8}>
                    <Checkbox value="sending_proposal">Proposal</Checkbox>
                  </Col>
                  <Col span={8}>
                    <Checkbox value="sending_contract">Contract</Checkbox>
                  </Col>
                  <Col span={8}>
                    <Checkbox value="sending_brochure">Brochure</Checkbox>
                  </Col>
                  <Col span={8}>
                    <Checkbox value="sending_other">Other</Checkbox>
                  </Col>
                </Row>
              </Checkbox.Group>
              {this.state.sendingOtherShow && (
                <div className="row">
                  <div className="col-md-4">
                    <FormItem label="">
                      {getFieldDecorator('sending_other_text', {
                        initialValue: contentData ? contentData.sending_other_text : ''
                      })(<Input placeholder="Other..." />)}
                    </FormItem>
                  </div>
                </div>
              )}
              {this.state.transmittalSendings.length > 0 && (
                <div>
                  <Table
                    dataSource={this.state.transmittalItems}
                    size="small"
                    bordered
                    pagination={false}
                    rowKey="id"
                  >
                    <Column
                      title="Date"
                      dataIndex="transmittal_date"
                      key="transmittal_date"
                      width={250}
                      render={(text, record) =>
                        this.renderColumns(
                          moment.utc(text).format('MM-DD-YYYY'),
                          record,
                          'transmittal_date'
                        )
                      }
                    />
                    <Column
                      title="Copies"
                      dataIndex="copies"
                      key="copies"
                      render={(text, record) => this.renderColumns(text, record, 'copies')}
                    />
                    <Column
                      title="Number"
                      dataIndex="number"
                      key="number"
                      render={(text, record) => this.renderColumns(text, record, 'number')}
                    />
                    <Column
                      title="Description"
                      dataIndex="description"
                      key="description"
                      render={(text, record) => this.renderColumns(text, record, 'description')}
                    />
                    <Column
                      title=" "
                      dataIndex="action"
                      key="action"
                      render={(text, record) => {
                        return (
                          <div>
                            {record.isEditingRow && (
                              <Button
                                icon="save"
                                size="small"
                                onClick={() => this.saveRow(record.id)}
                              />
                            )}
                            {!record.isEditingRow && (
                              <Button
                                icon="edit"
                                size="small"
                                onClick={() => this.editRow(record.id)}
                              />
                            )}
                            <Button
                              icon="caret-up"
                              size="small"
                              onClick={() => this.moveUp(record.id)}
                            />
                            <Button
                              icon="caret-down"
                              size="small"
                              onClick={() => this.moveDown(record.id)}
                            />
                            <Popconfirm
                              title="Are you sure you want to delete this line?"
                              onConfirm={() => this.deleteRow(record.id)}
                              onCancel={this.cancelDelete}
                              okText="Yes"
                              cancelText="No"
                            >
                              <Button
                                className="marginLeft5"
                                size="small"
                                type="danger"
                                icon="delete"
                              />
                            </Popconfirm>
                          </div>
                        )
                      }}
                      width={150}
                    />
                  </Table>
                  <AddItemArea>
                    <div className="row">
                      <div className="col-md-2">
                        <DatePicker
                          format="MM-DD-YYYY"
                          placeholder="Date"
                          value={this.state.addDateInput}
                          onChange={event => this.handleAddInputChange(event, 'addDateInput')}
                        />
                      </div>
                      <div className="col-md-2">
                        <InputNumber
                          placeholder="Copies"
                          value={this.state.addCopiesInput}
                          onChange={event => this.handleAddInputChange(event, 'addCopiesInput')}
                        />
                      </div>
                      <div style={{ width: '40px' }} />
                      <div className="col-md-2">
                        <InputNumber
                          placeholder="Number"
                          value={this.state.addNumberInput}
                          onChange={event => this.handleAddInputChange(event, 'addNumberInput')}
                        />
                      </div>
                      <div className="col-md-1" />
                      <div className="col-md-2">
                        <Input
                          placeholder="Description"
                          value={this.state.addDescriptionInput}
                          onChange={event =>
                            this.handleAddInputChange(event.target.value, 'addDescriptionInput')
                          }
                        />
                      </div>
                      <div className="col-md-2 text-right">
                        <Button onClick={() => this.handleAddItemClick()}>Add Item</Button>
                      </div>
                    </div>
                  </AddItemArea>
                </div>
              )}
              <h5>These are transmitted:</h5>
              <Checkbox.Group
                style={{ width: '100%' }}
                onChange={this.onTransmittedCheckBoxGroupChange}
                value={this.state.transmittalTransmitteds}
              >
                <Row>
                  <Col span={8}>
                    <Checkbox value="transmitted_for_review_and_approval">
                      For review and approval
                    </Checkbox>
                  </Col>
                  <Col span={8}>
                    <Checkbox value="transmitted_approved_as_submitted">
                      Approved as submitted
                    </Checkbox>
                  </Col>
                  <Col span={8}>
                    <Checkbox value="transmitted_resubmit">Resubmit x copies for approval</Checkbox>
                  </Col>
                  <Col span={8}>
                    <Checkbox value="transmitted_for_review_and_revision">
                      For review and revision
                    </Checkbox>
                  </Col>
                  <Col span={8}>
                    <Checkbox value="transmitted_approved_as_noted">Approved as noted</Checkbox>
                  </Col>
                  <Col span={8}>
                    <Checkbox value="transmitted_as_requested">As requested</Checkbox>
                  </Col>
                  <Col span={8}>
                    <Checkbox value="transmitted_other">Other</Checkbox>
                  </Col>
                </Row>
              </Checkbox.Group>
              {this.state.transmittedOtherShow && (
                <div className="row">
                  <div className="col-md-4">
                    <FormItem label="">
                      {getFieldDecorator('transmitted_other_text', {
                        initialValue: contentData ? contentData.transmitted_other_text : ''
                      })(<Input placeholder="Other..." />)}
                    </FormItem>
                  </div>
                </div>
              )}
              <br />
              {contentData && (
                <SignedFilesUploadContainer>
                  <div className="row">
                    <div className="col-md-6">
                      <h6>
                        <Icon type="file" /> Signed Files
                      </h6>
                    </div>
                    <div className="col-md-6 text-right">
                      {this.props.jobSiteTransmittalActions &&
                        this.props.jobSiteTransmittalActions.uploadingAttachment && (
                          <div className="text-success">
                            <Icon type="loading" /> Uploading File(s)
                          </div>
                        )}
                      {this.props.jobSiteTransmittalActions &&
                        this.props.jobSiteTransmittalActions.deletingAttachment && (
                          <div className="text-danger">
                            <Icon type="loading" /> Deleting File(s)
                          </div>
                        )}
                    </div>
                  </div>
                  {this.props.jobSiteTransmittalActions.jobTransmittalAttachments &&
                    this.props.jobSiteTransmittalActions.jobTransmittalAttachments.data.length >
                      0 && (
                      <Spin spinning={this.props.jobSiteTransmittalActions.loadingAttachments}>
                        <ReactTable
                          defaultPageSize={5}
                          data={this.props.jobSiteTransmittalActions.jobTransmittalAttachments.data}
                          getTrProps={(state, rowInfo, column, instance) => ({
                            onClick: e => this.handleAttachmentRowClick(rowInfo.original)
                          })}
                          defaultFilterMethod={filterCaseInsensitive}
                          columns={[
                            {
                              Header: 'Attached Files',
                              columns: [
                                {
                                  Header: 'Filename',
                                  id: 'filename',
                                  accessor: 'filename',
                                  Cell: d => (
                                    <Tooltip title={d.original.filename}>
                                      {d.original.filename}
                                    </Tooltip>
                                  )
                                },
                                {
                                  Header: 'Description',
                                  id: 'description',
                                  accessor: 'description',
                                  Cell: d => (
                                    <Tooltip title={d.original.description}>
                                      {d.original.description}
                                    </Tooltip>
                                  )
                                },
                                {
                                  Cell: row => (
                                    <Tooltip
                                      placement="left"
                                      title="Open this file on a new window"
                                    >
                                      <a target="_blank" href={row.original.signedUrl}>
                                        <Icon type="export" className="fontSize20" />
                                      </a>
                                    </Tooltip>
                                  ),
                                  maxWidth: 35
                                }
                              ]
                            }
                          ]}
                          defaultSorted={[
                            {
                              id: 'id',
                              desc: true
                            }
                          ]}
                          className="-striped -highlight"
                        />
                      </Spin>
                    )}
                  {this.state.attachmentDetailsVisible && (
                    <EditAttachmentContainer>
                      <EditAttachmentTitle>
                        <Icon type="edit" /> Edit Attachment Area
                      </EditAttachmentTitle>
                      <div>
                        <EditingFileContainer>
                          <Icon type="file" /> {this.state.attachmentName}
                        </EditingFileContainer>
                      </div>
                      <div className="row">
                        <div className="col-md-10">
                          <TextArea
                            placeholder="Describe the attachment..."
                            rows={4}
                            onChange={this.onDescriptionChange}
                            value={this.state.attachmentDescription}
                          />
                        </div>
                      </div>
                      <div className="d-flex flex-row mt-2">
                        <Button onClick={this.onChangeAttachmentDescription}>
                          <Icon type="save" /> OK
                        </Button>{' '}
                        <Popconfirm
                          title="Are you sure you want to delete this attachment?"
                          onConfirm={this.confirmAttachmentDelete}
                          okText="Yes"
                          cancelText="No"
                        >
                          <Button type="danger" icon="delete" className="ml-2">
                            {' '}
                            DELETE
                          </Button>
                        </Popconfirm>
                      </div>
                    </EditAttachmentContainer>
                  )}
                  <br />
                  <div>Upload Signed File(s)</div>
                  <br />
                  <Upload
                    {...uploadProps}
                    name="file"
                    customRequest={this.uploadAttachment}
                    onChange={this.onUploadChange}
                  >
                    <Button>
                      <Icon type="upload" /> Upload
                    </Button>
                  </Upload>
                </SignedFilesUploadContainer>
              )}
              <Popconfirm
                title="Are you sure you want to delete this record?"
                onConfirm={this.confirmDelete}
                onCancel={this.cancelDelete}
                okText="Yes"
                cancelText="No"
              >
                {contentData && <Button type="danger" icon="delete" />}
              </Popconfirm>
            </Form>
          </Modal>
        )}
        <div className="jobsBar">
          Transmittals
          <div className="jobsBarAdd">
            <i className="fa fa-plus-square" aria-hidden="true" />
            &nbsp;
            <div onClick={() => this.handleAddButton()} className="addJobLabel">
              ADD Transmittal
            </div>
          </div>
        </div>
        {this.props.jobSiteTransmittalActions.jobSiteTransmittals && (
          <ReactTable
            filterable
            defaultFilterMethod={filterCaseInsensitive}
            getTrProps={(state, rowInfo, column, instance) => ({
              onClick: e => this.handleRowClick(rowInfo.original)
            })}
            data={this.props.jobSiteTransmittalActions.jobSiteTransmittals.data}
            columns={[
              {
                columns: [
                  {
                    Header: 'Number',
                    accessor: 'number',
                    maxWidth: 90
                  },
                  {
                    Header: 'Description',
                    id: 'description',
                    accessor: 'description',
                    Cell: d => (
                      <Tooltip title={d.original.description}>{d.original.description}</Tooltip>
                    )
                  },
                  {
                    Header: 'Status',
                    accessor: 'status',
                    maxWidth: 90
                  },
                  {
                    Header: 'Created Date',
                    id: 'created_date',
                    accessor: d => moment.utc(d.created_date).format('M/D/YYYY h:mm:ssa'),
                    maxWidth: 200
                  }
                ]
              }
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = ({ jobSiteTransmittalActions, organizationsActions }, ownProps) => ({
  jobSiteTransmittalActions,
  organizationsActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, transmittalActions, organizationsActions), dispatch)
})

JobSiteTransmittals.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Form.create()(JobSiteTransmittals))
)



// WEBPACK FOOTER //
// ./src/containers/job/tasks/JobSiteTransmittals.js